/**
 * MCPBadge — popover d'intégration MCP
 * Wording orienté juristes / avocats non-dev.
 * Le popover est déclenché depuis le PublicHeader.
 * MCPBadge ne rend plus rien (widget bas gauche supprimé).
 */

import { useState } from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// ── Icônes ────────────────────────────────────────────────────────────────────

export const ClaudeIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg viewBox="0 0 512 509.64" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="512" height="509.64" rx="115.612" fill="#D97757" />
    <path fill="#FFFAF8" fillRule="nonzero" d="M142.27 316.619l73.655-41.326 1.238-3.589-1.238-1.996-3.589-.001-12.31-.759-42.084-1.138-36.498-1.516-35.361-1.896-8.897-1.895-8.34-10.995.859-5.484 7.482-5.03 10.717.935 23.683 1.617 35.537 2.452 25.782 1.517 38.193 3.968h6.064l.86-2.451-2.073-1.517-1.618-1.517-36.776-24.922-39.81-26.338-20.852-15.166-11.273-7.683-5.687-7.204-2.451-15.721 10.237-11.273 13.75.935 3.513.936 13.928 10.716 29.749 23.027 38.848 28.612 5.687 4.727 2.275-1.617.278-1.138-2.553-4.271-21.13-38.193-22.546-38.848-10.035-16.101-2.654-9.655c-.935-3.968-1.617-7.304-1.617-11.374l11.652-15.823 6.445-2.073 15.545 2.073 6.547 5.687 9.655 22.092 15.646 34.78 24.265 47.291 7.103 14.028 3.791 12.992 1.416 3.968 2.449-.001v-2.275l1.997-26.641 3.69-32.707 3.589-42.084 1.239-11.854 5.863-14.206 11.652-7.683 9.099 4.348 7.482 10.716-1.036 6.926-4.449 28.915-8.72 45.294-5.687 30.331h3.313l3.792-3.791 15.342-20.372 25.782-32.227 11.374-12.789 13.27-14.129 8.517-6.724 16.1-.001 11.854 17.617-5.307 18.199-16.581 21.029-13.75 17.819-19.716 26.54-12.309 21.231 1.138 1.694 2.932-.278 44.536-9.479 24.062-4.347 28.714-4.928 12.992 6.066 1.416 6.167-5.106 12.613-30.71 7.583-36.018 7.204-53.636 12.689-.657.48.758.935 24.164 2.275 10.337.556h25.301l47.114 3.514 12.309 8.139 7.381 9.959-1.238 7.583-18.957 9.655-25.579-6.066-59.702-14.205-20.474-5.106-2.83-.001v1.694l17.061 16.682 31.266 28.233 39.152 36.397 1.997 8.999-5.03 7.102-5.307-.758-34.401-25.883-13.27-11.651-30.053-25.302-1.996-.001v2.654l6.926 10.136 36.574 54.975 1.895 16.859-2.653 5.485-9.479 3.311-10.414-1.895-21.408-30.054-22.092-33.844-17.819-30.331-2.173 1.238-10.515 113.261-4.929 5.788-11.374 4.348-9.478-7.204-5.03-11.652 5.03-23.027 6.066-30.052 4.928-23.886 4.449-29.674 2.654-9.858-.177-.657-2.173.278-22.37 30.71-34.021 45.977-26.919 28.815-6.445 2.553-11.173-5.789 1.037-10.337 6.243-9.2 37.257-47.392 22.47-29.371 14.508-16.961-.101-2.451h-.859l-98.954 64.251-17.618 2.275-7.583-7.103.936-11.652 3.589-3.791 29.749-20.474z"/>
  </svg>
);

export const ChatGPTIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0L4.01 14.2A4.5 4.5 0 0 1 2.34 7.896zm16.597 3.855l-5.843-3.369 2.02-1.168a.076.076 0 0 1 .071 0l4.81 2.778a4.5 4.5 0 0 1-.676 8.084v-5.677a.79.79 0 0 0-.382-.648zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.814-2.772a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z"/>
  </svg>
);

export const MistralIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg viewBox="0 0 512 512" className={className} xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd">
    <defs>
      <clipPath id="mistral-a"><path d="M0 0h254.667v180H0z"/></clipPath>
      <clipPath id="mistral-b"><path d="M0 0h190.141v135H0z"/></clipPath>
    </defs>
    <g transform="translate(6 79.299) scale(1.96335)">
      <g clipPath="url(#mistral-a)">
        <g transform="scale(1.33333)">
          <g clipPath="url(#mistral-b)" fillRule="nonzero">
            <path fill="#ffd800" d="M27.153 0h27.169v27.089H27.153zM135.815 0h27.169v27.089h-27.169z"/>
            <path fill="#ffaf00" d="M27.153 27.091h54.329V54.18H27.153zM108.661 27.091h54.329V54.18h-54.329z"/>
            <path fill="#ff8205" d="M27.153 54.168h135.819v27.089H27.153z"/>
            <path fill="#fa500f" d="M27.153 81.259h27.169v27.09H27.153zM81.492 81.259h27.169v27.09H81.492zM135.815 81.259h27.169v27.09h-27.169z"/>
            <path fill="#e10500" d="M-.001 108.339h81.489v27.09H-.001zM108.661 108.339h81.498v27.09h-81.498z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const GeminiIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12"/>
  </svg>
);

// ── Config clients ────────────────────────────────────────────────────────────

interface Step {
  labelKey:   string;  // clé i18n (mcp.*)
  detail?:    string;
  noteKey?:   string;  // clé i18n — note explicative en italique sous l'étape
  apiKey?:    boolean; // étape spéciale avec lien vers la clé API
}

interface Client {
  id:              string;
  name:            string;
  icon:            ReactNode;
  iconHeader:      ReactNode;
  introKey:        string; // clé i18n — phrase d'accroche spécifique au client
  steps:           Step[];
  snippet?:        string;
  snippetLabelKey?: string; // clé i18n
  link:            { href: string; labelKey: string };
}

const API_KEY_URL = 'https://smartlawyer.ai/settings/api-key';

export const CLIENTS: Client[] = [
  {
    id:         'claude',
    name:       'Claude',
    icon:       <ClaudeIcon />,
    iconHeader: <ClaudeIcon className="w-3.5 h-3.5" />,
    introKey:   'mcp.clients.claude.intro',
    steps: [
      {
        labelKey: 'mcp.steps.create_key',
        apiKey:   true,
      },
      {
        labelKey: 'mcp.clients.claude.step_settings',
        noteKey:  'mcp.clients.claude.step_settings_note',
      },
      {
        labelKey: 'mcp.clients.claude.step_add',
      },
      {
        labelKey: 'mcp.clients.claude.step_paste',
        detail:   'https://mcp.smartlawyer.ai/mcp?api_key=sk-votre-cle',
        noteKey:  'mcp.clients.claude.step_paste_note',
      },
    ],
    snippet:         'https://mcp.smartlawyer.ai/mcp?api_key=sk-votre-cle',
    snippetLabelKey: 'mcp.clients.claude.snippet_label',
    link: { href: 'https://claude.ai/settings', labelKey: 'mcp.clients.claude.open' },
  },
  {
    id:         'chatgpt',
    name:       'ChatGPT',
    icon:       <ChatGPTIcon />,
    iconHeader: <ChatGPTIcon className="w-3.5 h-3.5" />,
    introKey:   'mcp.clients.chatgpt.intro',
    steps: [
      {
        labelKey: 'mcp.steps.create_key',
        apiKey:   true,
      },
      {
        labelKey: 'mcp.clients.chatgpt.step_settings',
      },
      {
        labelKey: 'mcp.clients.chatgpt.step_dev_mode',
        noteKey:  'mcp.clients.chatgpt.step_dev_mode_note',
      },
      {
        labelKey: 'mcp.clients.chatgpt.step_create',
        detail:   'https://mcp.smartlawyer.ai/mcp',
      },
      {
        labelKey: 'mcp.clients.chatgpt.step_auth',
        noteKey:  'mcp.steps.key_in_settings',
      },
    ],
    snippet:         'https://mcp.smartlawyer.ai/mcp',
    snippetLabelKey: 'mcp.clients.chatgpt.snippet_label',
    link: { href: 'https://chatgpt.com', labelKey: 'mcp.clients.chatgpt.open' },
  },
  {
    id:         'mistral',
    name:       'Le Chat',
    icon:       <MistralIcon />,
    iconHeader: <MistralIcon className="w-3.5 h-3.5" />,
    introKey:   'mcp.clients.mistral.intro',
    steps: [
      {
        labelKey: 'mcp.steps.create_key',
        apiKey:   true,
      },
      {
        labelKey: 'mcp.clients.mistral.step_settings',
      },
      {
        labelKey: 'mcp.clients.mistral.step_choose',
      },
      {
        labelKey: 'mcp.steps.paste_server',
        detail:   'https://mcp.smartlawyer.ai/mcp',
      },
      {
        labelKey: 'mcp.steps.paste_key_auth',
        noteKey:  'mcp.steps.key_in_settings',
      },
    ],
    snippet:         'https://mcp.smartlawyer.ai/mcp',
    snippetLabelKey: 'mcp.clients.mistral.snippet_label',
    link: { href: 'https://chat.mistral.ai', labelKey: 'mcp.clients.mistral.open' },
  },
  {
    id:         'gemini',
    name:       'Gemini',
    icon:       <GeminiIcon />,
    iconHeader: <GeminiIcon className="w-3.5 h-3.5" />,
    introKey:   'mcp.clients.gemini.intro',
    steps: [
      {
        labelKey: 'mcp.steps.create_key',
        apiKey:   true,
      },
      {
        labelKey: 'mcp.clients.gemini.step_settings',
      },
      {
        labelKey: 'mcp.clients.gemini.step_choose',
      },
      {
        labelKey: 'mcp.steps.paste_server',
        detail:   'https://mcp.smartlawyer.ai/mcp',
      },
      {
        labelKey: 'mcp.steps.paste_key_auth',
        noteKey:  'mcp.steps.key_in_settings',
      },
    ],
    snippet:         'https://mcp.smartlawyer.ai/mcp',
    snippetLabelKey: 'mcp.clients.gemini.snippet_label',
    link: { href: 'https://gemini.google.com', labelKey: 'mcp.clients.gemini.open' },
  },
];

// ── Couleur dot par client ────────────────────────────────────────────────────
const CLIENT_DOTS: Record<string, string> = {
  claude:  '#d97706',
  chatgpt: '#10a37f',
  mistral: '#FF7000',
  gemini:  '#4285f4',
};

// ── Popover ───────────────────────────────────────────────────────────────────

interface MCPPopoverProps {
  onClose:   () => void;
  position?: 'bottom-left' | 'bottom-right' | 'bottom-center';
}

export const MCPPopover = ({ onClose }: MCPPopoverProps) => {
  const { t } = useTranslation();
  const [active, setActive] = useState('claude');
  const [copied, setCopied] = useState(false);
  const current = CLIENTS.find(c => c.id === active)!;

  const handleCopy = () => {
    navigator.clipboard.writeText(current.snippet ?? '');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // posClass neutralisé — le popover est rendu via createPortal dans PublicHeader
  // le wrapper fixed externe gère le positionnement
  const posClass = '';

  return (
    <div className={`${posClass} w-[92vw] sm:w-[560px] rounded-2xl border border-violet-200 dark:border-violet-800/60 bg-card shadow-2xl shadow-violet-900/10 overflow-hidden z-50`}>

      {/* ── En-tête violet ── */}
      <div className="bg-violet-50 dark:bg-violet-950/40 border-b border-violet-200 dark:border-violet-800/60 px-5 py-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-widest text-violet-600 dark:text-violet-400 mb-1">
            {t('mcp.popover.title')}
          </p>
          <p className="text-sm text-foreground leading-relaxed italic">
            {t(current.introKey)}
          </p>
        </div>
        <button onClick={onClose} aria-label={t('common.close')}
          className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg text-muted-foreground hover:text-foreground hover:bg-violet-100 dark:hover:bg-violet-900/40 transition-colors mt-0.5">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* ── Corps : 2 colonnes ── */}
      <div className="grid grid-cols-[180px_1fr] sm:grid-cols-[200px_1fr] divide-x divide-border">

        {/* Colonne gauche — sélecteur clients */}
        <div className="py-3 bg-muted/20">
          <p className="px-4 pb-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
            {t('mcp.popover.choose_ai')}
          </p>
          {CLIENTS.map(c => (
            <button
              key={c.id}
              onClick={() => setActive(c.id)}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-left transition-colors ${
                active === c.id
                  ? 'bg-violet-50 dark:bg-violet-950/40 text-violet-700 dark:text-violet-300'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground'
              }`}
            >
              {/* Dot couleur */}
              <span
                className="flex-shrink-0 w-2 h-2 rounded-full"
                style={{ background: CLIENT_DOTS[c.id] ?? '#888' }}
              />
              {/* Icône */}
              <span className="flex-shrink-0 opacity-80">{c.iconHeader}</span>
              {/* Nom */}
              <span className="text-[13px] font-semibold">{c.name}</span>
              {/* Indicateur actif */}
              {active === c.id && (
                <svg className="ml-auto w-3.5 h-3.5 text-violet-600 dark:text-violet-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                </svg>
              )}
            </button>
          ))}

          {/* Mention "+ autres" */}
          <p className="px-4 pt-2 text-[11px] text-muted-foreground/60">{t('mcp.popover.others')}</p>
        </div>

        {/* Colonne droite — contenu */}
        <div className="flex flex-col">

          {/* Étapes */}
          <div className="px-5 py-4 space-y-3 flex-1 overflow-y-auto max-h-[280px]">
            <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-1">
              {t('mcp.popover.how_to')}
            </p>
            <ol className="space-y-3">
              {current.steps.map((s, i) => (
                <li key={i} className="flex gap-3">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-300 font-bold flex items-center justify-center text-[10px] mt-0.5">
                    {i + 1}
                  </span>
                  <div className="space-y-1 min-w-0">
                    <p className="text-xs text-foreground leading-relaxed">{t(s.labelKey)}</p>
                    {s.detail && (
                      <code className="block text-[10px] bg-muted px-2 py-1.5 rounded-lg font-mono text-violet-700 dark:text-violet-300 break-all border border-violet-200 dark:border-violet-800/40">
                        {s.detail}
                      </code>
                    )}
                    {s.noteKey && (
                      <p className="text-[10px] text-muted-foreground italic">{t(s.noteKey)}</p>
                    )}
                    {s.apiKey && (
                      <a href={API_KEY_URL} target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-[11px] font-semibold text-violet-600 dark:text-violet-400 hover:underline mt-0.5">
                        {t('mcp.popover.get_key')}
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </a>
                    )}
                  </div>
                </li>
              ))}
            </ol>

            {/* Snippet URL */}
            {current.snippet && (
              <div className="space-y-1 pt-1">
                <p className="text-[10px] text-muted-foreground font-medium">{current.snippetLabelKey ? t(current.snippetLabelKey) : null}</p>
                <div className="relative">
                  <pre className="text-[10px] bg-muted/60 border border-violet-200 dark:border-violet-800/40 rounded-lg px-3 py-2.5 overflow-x-auto font-mono text-violet-700 dark:text-violet-300 whitespace-pre-wrap break-all pr-16">
                    {current.snippet}
                  </pre>
                  <button onClick={handleCopy}
                    className="absolute top-2 right-2 text-[10px] px-2 py-1 rounded-md bg-background border border-violet-200 dark:border-violet-800/40 hover:bg-violet-50 dark:hover:bg-violet-950/40 transition-colors font-semibold text-violet-700 dark:text-violet-300">
                    {copied ? `✓ ${t('common.copied')}` : t('common.copy')}
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Actions — pied */}
          <div className="flex items-center gap-2 px-5 py-3 border-t border-border/60 bg-muted/20">
            <a href={API_KEY_URL} target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-center gap-1.5 flex-1 text-xs px-3 py-2 rounded-lg border border-violet-200 dark:border-violet-800/60 hover:bg-violet-50 dark:hover:bg-violet-950/40 text-muted-foreground hover:text-violet-700 dark:hover:text-violet-300 transition-colors font-medium">
              {t('mcp.popover.my_key')}
            </a>
            <a href={current.link.href} target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-center gap-1.5 flex-1 text-xs px-3 py-2 rounded-lg bg-violet-600 text-white hover:bg-violet-700 transition-colors font-semibold">
              {t(current.link.labelKey)}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── MCPBadge — widget bas gauche supprimé, conservé pour compatibilité ────────
export const MCPBadge = () => null;